import { render, staticRenderFns } from "./AlarmSiloList.vue?vue&type=template&id=45ff3198"
import script from "./AlarmSiloList.vue?vue&type=script&lang=js"
export * from "./AlarmSiloList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports